export const gridCardItems = [
    {
      id: 1,
      picture: "https://cdn.getyourguide.com/img/tour/5824f8b50d3f3.jpeg/145.jpg",
      title: "Circuits maroc ",
      price: "1200",
      date: "Jan 02, 2019",
      smallDescription:
        "How many free autoresponders have you tried? And how many emails did you get through using them",
      nbPlace: 6,
      activities: ["activite 1", "activite 2", "activite 3"],
    },
    {
      id: 2,
      picture: "https://res.cloudinary.com/hello-tickets/image/upload/c_limit,f_auto,q_auto,w_1300/v1645588616/j4ssef2gssrjvzxbbqpr.jpg",
      title: "Trip to somewhere",
      price: "1200",
      date: "Jan 02, 2019",
      smallDescription:
        "How many free autoresponders have you tried? And how many emails did you get through using them",
      nbPlace: 6,
      activities: ["activite 1", "activite 2", "activite 3"],
    },
    {
      id: 3,
      picture: "https://www.visitmorocco.com/sites/default/files/styles/thumbnail_events_slider/public/thumbnails/image/city-panorama.-casablanca-morocco.-africa-marianna-ianovska.jpg?itok=h4FjZSIp",
      title: "Trip to somewhere",
      price: "1200",
      date: "Jan 02, 2019",
      smallDescription:
        "How many free autoresponders have you tried? And how many emails did you get through using them",
      nbPlace: 6,
      activities: ["activite 1", "activite 2", "activite 3"],
    },
    {
      id: 4,
      picture: "https://www.tracedirecte.com/media/original_images/rabat-maroc.jpg.1920x0_q85_format-jpg.jpg",
      title: "Trip to somewhere",
      price: "1200",
      date: "Jan 02, 2019",
      smallDescription:
        "How many free autoresponders have you tried? And how many emails did you get through using them",
      nbPlace: 6,
      activities: ["activite 1", "activite 2", "activite 3"],
    },
    {
      id: 5,
      picture: "https://images.unsplash.com/photo-1533501747004-381b96042e88?auto=format&fit=crop&q=80&w=1000&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8dGFuZ2VyfGVufDB8fDB8fHww",
      title: "Trip to somewhere",
      price: "1200",
      date: "Jan 02, 2019",
      smallDescription:
        "How many free autoresponders have you tried? And how many emails did you get through using them",
      nbPlace: 6,
      activities: ["activite 1", "activite 2", "activite 3"],
    },
    {
      id: 6,
      picture: "https://www.visitmorocco.com/sites/default/files/styles/thumbnail_illustration_detail_mini_slider/public/kasbah3_0.png?itok=Xi7sQrCN",
      title: "Trip to somewhere",
      price: "1200",
      date: "Jan 02, 2019",
      smallDescription:
        "How many free autoresponders have you tried? And how many emails did you get through using them",
      nbPlace: 6,
      activities: ["activite 1", "activite 2", "activite 3"],
    },
  ];
  